import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      redirect:"/history/index",
      component: ()=>import('@/components/index'),
    },
    {
      path: '/history',
      component: Layout,
      redirect:"/history/index",
      name: '历史数据',
      children:[
        {
          path:"index",
          component: ()=>import('@/components/history'),
        }
      ]
    },
    {
      path: '/indata',
      component: Layout,
      redirect:"/indata/index",
      name: '数据处理',
      children:[
        {
          path:"index",
          component: ()=>import('@/components/indata'),
        }
      ]
    },
    {
      path: '/user',
      component: Layout,
      redirect:"/user/index",
      name: '用户管理',
      children:[
        {
          path:"index",
          component: ()=>import('@/components/user'),
        }
      ]
    },
    {
      path: '/view',
      component: ()=>import('@/components/chart')
    },
    {
      path: '/polyline',
      name: '折线图',
      component: Layout,
      redirect:"/Polyline/index",
      children:[
        {
          path:"index",
          component: ()=>import('@/components/polyline'),
        }
      ]
    },
    {
      path: '/pie',
      name: '饼状图',
      component: Layout,
      redirect:"/pie/index",
      children:[
        {
          path:"index",
          component: ()=>import('@/components/piechart'),
        }
      ]
    },
    {
      path: '/login',
      component: ()=>import('@/components/login')
    }
  ]
})




// export const constantRoutes = [
//   {
//     path: '/',
//     component: Layout,
//     redirect:"/history/index",
//     component: ()=>import('@/components/index'), 
//     hidden: true 
//   },
//   {
//     path: '/view',
//     component: ()=>import('@/components/chart'), 
//     hidden: true 
//   },
// ]

// export const asyncRoutes = [
//   {
//     path: '/history',
//     component: Layout,
//     redirect:"/history/index",
//     name: '历史记录',
//     children:[
//       {
//         path:"index",
//         component: ()=>import('@/components/history'),
//       }
//     ]
//   },
//   {
//     path: '/indata',
//     component: Layout,
//     redirect:"/indata/index",
//     name: '生成数据',
//     children:[
//       {
//         path:"index",
//         component: ()=>import('@/components/indata'),
//       }
//     ]
//   },
// ]
// const createRouter = () => new Router({
//   scrollBehavior: () => ({ y: 0 }),
//   routes: constantRoutes
// })
// const router = createRouter()
// export function resetRouter() {
//   const newRouter = createRouter()
//   router.matcher = newRouter.matcher // reset router
// }
// export default router


// WEBPACK FOOTER //
// ./src/router/index.js